import { t } from 'i18next';
import { bicycleOutline, storefrontOutline } from 'ionicons/icons';

import { DISPATCH_METHODS } from '~constants/address';

export const TABS_DATA = [
  {
    id: 0,
    value: DISPATCH_METHODS.PJ_DELIVERY,
    title: t('DeliveryOrPickUp:delivery'),
    icon: bicycleOutline,
    yellowBtnStyle: true
  },
  {
    id: 1,
    value: DISPATCH_METHODS.IN_STORE,
    title: t('DeliveryOrPickUp:near'),
    icon: storefrontOutline,
    yellowBtnStyle: true
  }
];
